import React, {useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import {Form} from 'react-bootstrap';
import Select from 'react-select';
export default function StepSummary(props) {
  //   const [allow, setAllow] = useState(true);
  //   useEffect(() => {
  //     if (props.places) {
  //       setAllow(props.item.agreeExpend);
  //     }
  //   }, [props.places]);

  return (
    <div className="row">
      <Form.Group className="mb-2 col-md-12">
        <Form.Label>โยกงบเดือน</Form.Label>
        <Select
          isMulti
          value={props.data3
            .filter((e) => e.select)
            .map((el) => ({...el, label: el.month, value: el.month}))}
          menuPlacement="top"
          className="basic-multi-select"
          classNamePrefix="select"
          options={props.data3
            .filter((e) => e.select)
            .map((el) => ({...el, label: el.month, value: el.month}))}
          disabled
        />
      </Form.Group>
      <Form.Group className="mb-2 col-md-4">
        <Form.Label>Cost Center</Form.Label>
        <Select
          className="col-12 col-md-12 mb-2"
          value={props.dropdownCostcenter.DATA.filter(
            (e) => e.value === props.costIdSelect
          )}
          placeholder={'เลือกกลุ่มต้นทุน'}
          disabled
          // options={
          //   data.companyid === ''
          //     ? props.dropdownCostcenter.DATA
          //     : props.dropdownCostcenter.DATA.filter(
          //         (e) => e.company === data.companyid
          //       )
          // }
        />
      </Form.Group>
      <Form.Group className="mb-2 col-md-4">
        <Form.Label>ไปไว้เดือน</Form.Label>
        <Form.Control
          disabled
          type="text"
          className="form-control"
          value={[props.yearMonthSelect.slice(0, 4), "-", props.yearMonthSelect.slice(4)].join('')}
        />
      </Form.Group>
      <Form.Group className="mb-2 col-md-4">
        <Form.Label>รวม</Form.Label>
        <div className="input-group col-12">
          <div className="input-group-prepend">
            <div className="input-group-text" style={{width: 130}}>
              {'รวม'}
            </div>
          </div>
          <input
            style={{
              textAlign: 'right',
              backgroundColor: 'white'
            }}
            disabled
            type="text"
            className="form-control"
            value={props.data3
              .filter((e) => e.select)
              .reduce(
                (prev, curr) =>
                  prev + Number(curr.costRemain.replace(/,/g, '')),
                0
              )}
          />
        </div>
      </Form.Group>
      <Form.Group className="mb-3 col-md-12">
        <Form.Control
          as="textarea"
          rows="3"
          placeholder={`กรอกเหตุผลประกอบการขอโยกงบ\nกรณีต้องการถัวเฉลี่ยงบไปปลายทางหลายเดือนกรุณาเขียนอธิบายแจ้งให้พอเข้าใจ\nเช่น งบ 10,000 บาท เข้า ม.ค.2568 จำนวน 5,000 บาท และเข้า ก.พ.2568 จำนวน 5,000 บาท`}
          onChange={(e) => {
            props.setReason(e.target.value);
          }}
        />
      </Form.Group>
    </div>
  );
}
